import { Stack } from '@mui/material';
import { FunctionComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import StorageExplorer from '../components/StorageExplorer';
import './Storage.scss';
import StorageFileType from './UserRoleType';

interface StorageProps extends RouteComponentProps {
    progress: Function;
}

const Storage: FunctionComponent<StorageProps> = (props: StorageProps) => (
    <div className="StorageRoot">
        <Stack direction="column" className="Storage">
            <StorageExplorer allowedfilterType={StorageFileType.all} progress={props.progress} {...props} />
        </Stack>
    </div>
);

export default Storage;
